/**
 * WorkspaceSuggestedQuestions
 *
 * Tap-to-fill suggested questions with sparkle (✨) prefix icons.
 * Navigates to On the Record with the question pre-filled.
 */

import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface WorkspaceSuggestedQuestionsProps {
  questions: string[];
  workspaceId: string;
}

export const WorkspaceSuggestedQuestions: React.FC<
  WorkspaceSuggestedQuestionsProps
> = ({ questions, workspaceId }) => {
  const navigate = useNavigate();

  const handleAsk = (q: string) => {
    navigate(`/tools/on-the-record?workspace=${workspaceId}`, {
      state: {
        preselectedWorkspaceId: workspaceId,
        prefillQuestion: q,
      },
    });
  };

  if (questions.length === 0) return null;

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5">
      <p className="mb-4 text-[11px] font-semibold uppercase tracking-widest text-gray-400">
        Suggested Questions
      </p>
      <ul className="divide-y divide-gray-100">
        {questions.map((q, i) => (
          <li
            key={i}
            className="group flex cursor-pointer items-start gap-2.5 py-3 first:pt-0 last:pb-0
                       hover:bg-gray-50 -mx-1 px-1 rounded-lg transition-colors"
            onClick={() => handleAsk(q)}
          >
            {/* Sparkle icon */}
            <span className="mt-0.5 flex-shrink-0 text-sm leading-none text-gray-400">
              ✦
            </span>
            <span className="min-w-0 flex-1 text-sm text-gray-700 leading-snug">
              {q}
            </span>
            <ArrowUpRight className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-gray-300 group-hover:text-gray-500" />
          </li>
        ))}
      </ul>
    </div>
  );
};
